<template>
  <el-container id="container">
    <el-header>
      <router-link to="/" class="app-title">{{appName}}</router-link>
    </el-header>
    <el-main>
      <slot></slot>
    </el-main>
    <el-footer>
      &copy;{{`${new Date().getFullYear()}`}}
      <span style="padding-left: 2px;"><a href="http://www.ncut.edu.tw" target="_blank">國立勤益科技大學</a></span>
    </el-footer>
  </el-container>
</template>

<script>
  import appNameMixin from '../appNameMixin';
  export default {
    name: 'LoginLayout',
    mixins:[appNameMixin],
  }
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,500,700,900&subset=chinese-traditional');

  #container{
    min-height: 100vh;
    background-color: #f0f2f5;
  }

  #container .el-header{
    background: #1867c0;
    padding-right: 15px;
  }

  #container .el-header .app-title{
    font-family: 'Noto Sans TC', sans-serif !important;
    line-height: 60px;
    font-size: 24px;
    color: white;
    text-decoration: none;
  }

  #container .el-main .content{

  }

  #container .el-footer{
    font-family: 'Noto Sans TC', sans-serif !important;
    text-align: center;
    background: #fff;
    color: #444;
  }
  #container .el-footer a{
    text-decoration: none;
    font-size: 14px;
    line-height: 60px;
  }

</style>
